// extracted by mini-css-extract-plugin
export default {"display":"XfPAlA","iframe":"lvXnHt","skeleton":"UbF6D2","skeletonGroup":"QU7idM"};